import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { filter, map, switchMap } from 'rxjs/operators';
import { CxApiMetadataService, CxApiMetadataStrategy } from '../cx-api-metadata/cx-api-metadata.service';
import { CxApiMetadataEntity } from '../cx-api-metadata/store/reducers/cx-api-metadata.reducer';
import CxSalesLocationAction, { CxSalesLocationRequest } from './store/actions/cx-sales-location.actions';
import { CxSalesLocationEntity, CxSalesLocationState } from './store/reducers/cx-sales-location.reducer';
import * as cxSalesLocationSelector from './store/selectors/cx-sales-location.selector';

@Injectable({
  providedIn: 'root',
})
export class CxSalesLocationService {
  constructor(
    private store: Store<CxSalesLocationState>,
    private cxApiMetadata: CxApiMetadataService,
  ) {}

  public selectSalesLocations$(productTypeRequest: CxSalesLocationRequest, strategy?: CxApiMetadataStrategy) {
    return this.cxApiMetadata.connectMetadata$(CxSalesLocationAction.fetchEntity(productTypeRequest), strategy).pipe(
      switchMap((metadata) =>
        this.store.select(cxSalesLocationSelector.selectCxSalesLocationsById(), { ids: metadata.entityIds }).pipe(
          filter((res) => res.length === metadata.entityIds.length),
          map((res) => [res, metadata] as [CxSalesLocationEntity[], CxApiMetadataEntity]),
        ),
      ),
    );
  }

  public selectActive$() {
    return this.store.select(cxSalesLocationSelector.selectActiveCxSalesLocation);
  }

  public setActive(entityId: string | number) {
    return this.store.dispatch(CxSalesLocationAction.selectEntity({ id: `${entityId}` }));
  }
}
